// All distances and collisions use pitch coordinates, never drawing height.
export const LEVELS = [
  {name:'La primera asistencia', start:{x:300,y:540}, team:[{x:170,y:320}], defenders:[{x:300,y:350},{x:260,y:200}]},
  {name:'Cambio de banda', start:{x:100,y:530}, team:[{x:440,y:370},{x:300,y:230}], defenders:[{x:270,y:450},{x:365,y:290},{x:240,y:160}]},
  {name:'Triángulo ofensivo', start:{x:480,y:540}, team:[{x:160,y:400},{x:400,y:250}], defenders:[{x:320,y:470},{x:280,y:325},{x:350,y:155}]},
  {name:'Una pared para entrar', start:{x:300,y:550}, team:[{x:100,y:390},{x:280,y:280},{x:440,y:200}], defenders:[{x:210,y:460},{x:185,y:330},{x:355,y:245},{x:315,y:150}]},
  {name:'La jugada decisiva', start:{x:100,y:540}, team:[{x:430,y:420},{x:170,y:290},{x:330,y:200}], defenders:[{x:265,y:480},{x:300,y:350},{x:245,y:240},{x:380,y:145}]},
];
export const distance=(a,b)=>Math.hypot(a.x-b.x,a.y-b.y);
const clamp=(n,a,b)=>Math.max(a,Math.min(b,n));
export function kickPath(start, points) {
  const end=points[points.length-1];
  if(!end || distance(start,end)<28) return null;
  const dx=end.x-start.x,dy=end.y-start.y,len=distance(start,end);
  const nx=-dy/len,ny=dx/len;
  // Fit a bounded smooth quadratic: scribbles cannot create loops or sharp turns.
  let sum=0,weight=0;
  for(const p of points){const t=((p.x-start.x)*dx+(p.y-start.y)*dy)/(len*len);if(t>.08&&t<.92){const basis=2*t*(1-t);sum+=basis*((p.x-start.x)*nx+(p.y-start.y)*ny);weight+=basis*basis;}}
  const bend=clamp(weight?sum/weight:0,-len*.55,len*.55);
  return {start,end,control:{x:(start.x+end.x)/2+nx*bend,y:(start.y+end.y)/2+ny*bend}};
}
export function pathPoint(path,t){const u=1-t;return {x:u*u*path.start.x+2*u*t*path.control.x+t*t*path.end.x,y:u*u*path.start.y+2*u*t*path.control.y+t*t*path.end.y};}
export const pathSvg=p=>`M${p.start.x} ${p.start.y}Q${p.control.x} ${p.control.y} ${p.end.x} ${p.end.y}`;
export function beginKick(level,stage,points){
  const start=stage?level.team[stage-1]:level.start, path=kickPath(start,points);
  if(!path)return null;
  let length=0,previous=start; const samples=[{t:0,d:0}];
  for(let i=1;i<=100;i++){const p=pathPoint(path,i/100);length+=distance(previous,p);samples.push({t:i/100,d:length});previous=p;}
  return {path,samples,length,travel:0,ball:start,time:0,keeperX:300,result:null,shooting:stage===level.team.length,target:level.team[stage],defenders:level.defenders};
}
export function stepKick(old,dt){
  if(old.result)return old;
  const s={...old};let remaining=Math.min(.1,Math.max(0,dt));
  while(remaining>0&&!s.result){
    const h=Math.min(remaining,1/120);remaining-=h;s.time+=h;
    const previous=s.ball;
    s.travel=Math.min(s.length,s.travel+h*(s.shooting?370:245));
    let i=1;while(i<s.samples.length-1&&s.samples[i].d<s.travel)i++;
    const a=s.samples[i-1],b=s.samples[i];
    s.ball=pathPoint(s.path,a.t+(b.t-a.t)*(s.travel-a.d)/(b.d-a.d));
    if(s.shooting&&s.time>.22)s.keeperX+=clamp(clamp(s.ball.x,235,365)-s.keeperX,-85*h,85*h);
    if(s.ball.x<35||s.ball.x>565||s.ball.y>595)s.result='out';
    if(!s.result&&s.defenders.some(d=>distance(d,s.ball)<21))s.result='intercepted';
    if(!s.result&&s.shooting&&previous.y>106&&s.ball.y<=106){const f=(previous.y-106)/(previous.y-s.ball.y),x=previous.x+(s.ball.x-previous.x)*f;if(Math.abs(x-s.keeperX)<26)s.result='saved';}
    if(!s.result&&previous.y>90&&s.ball.y<=90){const f=(previous.y-90)/(previous.y-s.ball.y),x=previous.x+(s.ball.x-previous.x)*f;s.ball={x,y:90};s.result=!s.shooting?'early':Math.abs(x-220)<8||Math.abs(x-380)<8?'post':x>228&&x<372?'goal':'out';}
    if(!s.result&&s.travel>=s.length)s.result=!s.shooting&&distance(s.ball,s.target)<28?'received':s.shooting?'short':'lost';
  }
  return s;
}
export const levelScore=(level,failures)=>100+level.team.length*50+(3-failures)*30;
